export const ROOT_URL = `${window.location.protocol}//${window.location.host}`;

export const REACT_APP_API_BASE_URL =
  (typeof window !== 'undefined' &&
    window.env &&
    window.env.REACT_APP_API_BASE_URL) ||
  import.meta.env.REACT_APP_API_BASE_URL;

export const REACT_APP_GOOGLE_API_KEY =
  (typeof window !== 'undefined' &&
    window.env &&
    window.env.REACT_APP_GOOGLE_API_KEY) ||
  import.meta.env.REACT_APP_GOOGLE_API_KEY;

export const REACT_APP_VERSION =
  (typeof window !== 'undefined' &&
    window.env &&
    window.env.REACT_APP_VERSION) ||
  import.meta.env.REACT_APP_VERSION;

export const REACT_DEFAULT_DATE =
  (typeof window !== 'undefined' &&
    window.env &&
    window.env.REACT_APP_DEFAULT_DATE) ||
  import.meta.env.REACT_APP_DEFAULT_DATE;

export const REACT_COLLISION_REPORT_SYSTEM_URL =
  (typeof window !== 'undefined' &&
    window.env &&
    window.env.REACT_APP_COLLISION_REPORT_SYSTEM_URL) ||
  import.meta.env.REACT_APP_COLLISION_REPORT_SYSTEM_URL;

export const REACT_CREATE_NEW_USER_URL =
  (typeof window !== 'undefined' &&
    window.env &&
    window.env.REACT_APP_CREATE_NEW_USER_URL) ||
  import.meta.env.REACT_APP_CREATE_NEW_USER_URL;

export const REACT_ALBERTA_CA_ACCOUNT_URL =
  (typeof window !== 'undefined' &&
    window.env &&
    window.env.REACT_APP_ALBERTA_CA_ACCOUNT_URL) ||
  import.meta.env.REACT_APP_ALBERTA_CA_ACCOUNT_URL;

export const REACT_ALBERTA_CA_KEYCLOAK_URL =
  (typeof window !== 'undefined' &&
    window.env &&
    window.env.REACT_APP_ALBERTA_CA_KEYCLOAK_URL) ||
  import.meta.env.REACT_APP_ALBERTA_CA_KEYCLOAK_URL;

export const REACT_ALBERTA_CA_KEYCLOAK_REALM =
  (typeof window !== 'undefined' &&
    window.env &&
    window.env.REACT_APP_ALBERTA_CA_KEYCLOAK_REALM) ||
  import.meta.env.REACT_APP_ALBERTA_CA_KEYCLOAK_REALM;

export const REACT_ALBERTA_CA_KEYCLOAK_CLIENT_ID =
  import.meta.env.REACT_APP_ALBERTA_CA_KEYCLOAK_CLIENT_ID || 'ui-client';
